::Object.require 'opal/base'
::Object.require 'opal/mini'

::Object.require 'corelib/kernel/format'
::Object.require 'corelib/string/encoding'
::Object.autoload :Math, 'corelib/math'
::Object.require 'corelib/complex/base'
::Object.autoload :Complex, 'corelib/complex'
::Object.require 'corelib/rational/base'
::Object.autoload :Rational, 'corelib/rational'
::Object.require 'corelib/time'
::Object.autoload :Struct, 'corelib/struct'
::Object.autoload :Set, 'corelib/set'
::Object.autoload :Dir, 'corelib/dir'
::Object.autoload :File, 'corelib/file'

::Object.require 'corelib/process/base'
::Object.autoload :Process, 'corelib/process'
::Object.autoload :Random, 'corelib/random'

::Object.require 'corelib/unsupported'

::Object.require 'corelib/binding'
::Object.require 'corelib/irb'
